import { unwrapResult } from "@reduxjs/toolkit";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useMemo } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Col, Form, Label, Row, Spinner } from "reactstrap";
import { Block, BlockHead, BlockHeadContent, BlockTitle, Icon, PreviewCard } from "../../components/Component";
import Content from "../../layout/content/Content";
import { createNewReminder, createNewOrder } from "../../redux/slices/orderSlice";
import { fetchReminders } from "../../redux/slices/reminderSlice";
import { fetchUsers, updateUser } from "../../redux/slices/userSlice";

const AssignSpecialistForm = ({ onClick, data, isEdit = false }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { control, register, handleSubmit, errors, getValues, setValue } = useForm({
    defaultValues: {
      stages: [{ stageName: "" }],
    },
  });

  // const [startTime, setStartTime] = useState(new Date());

  const roles = useSelector((state) => state.role.roles);
  const specialists = useSelector((state) => state.user.filteredUsers);

  const stages = useSelector((state) => state.reminder.reminders);
  const isLoading = useSelector((state) => state.order.isLoading);



  useEffect(() => {
    // if (data?.specialist_id) {
    if (data?.specialist_id) {
      setValue("specialist", data?.specialist_id);
    }
    // }
    // Update specialist selection on initial load
  }, [data, data?.specialist_id, setValue]);
  
  const onFormSubmit = async (formData) => {
	// Create new order for select patient sent and transfer to new order pipeline

	//try {
     // const resultAction = await dispatch(
	
		//	createNewOrder({
        //      data: {
        //        user_id: data?.id, //Number(formData.id),
		//		specialist: formData.specialist,
                //work_type_id: data.work_type_id,
         //     },
         //     history,
         //     specialist: formData.specialist,
         //     note: '',
         //   })
     // );
     // const originalPromiseResult = unwrapResult(resultAction);
     // originalPromiseResult.history && originalPromiseResult.history.push("/orders-list");
    //} catch (error) {}
	 
	
    // Prepare reminder configuration data
    const reminderData = {
      //order_id: data?.id,
			// TODO: Make reminder time configurable
			// Default to 9:00 AM for now
     // time: "9:00",
			// Map selected stage IDs to integers
     // reminders: formData.stages.map((s) => parseInt(s.stageName)),
    };
	 try {
      // Dispatch action to create Enroll order update
      const resultAction = await dispatch(
        updateUser({
				id:data?.id,
				data:{
				enroll_status: 6, // Set user enroll status to enroll completed and remove from list
				},
				fetchOrdersAgain: false,
        })
      );
      // Unwrap result to handle success/error
      const originalPromiseResult = unwrapResult(resultAction);
	    if (onClick) {
      onClick();
    }
	 window.location.reload();
      originalPromiseResult.history &&
        originalPromiseResult.history.push("/enroll"); //`/reminders?specialist=${getValues().specialist}`);
    } catch (error) {}

    
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "stages",
  });

  const addStage = () => {
    append({ stageName: "" });
  };

  const formClass = classNames({
    "form-validate": true,
    "is-alter": true,
  });

  return (
    <React.Fragment>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
Are you Sure?
       
              </BlockTitle>
            </BlockHeadContent>
          </BlockHead>
          <PreviewCard>
            <Form onSubmit={handleSubmit(onFormSubmit)} className={formClass}>
              <Row className="g-gs">
                {/* Specialist Name */}
                <Col md="12">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="specialist-name">
                      Do you want to Finalize the Enrollment?
                    </Label>
                  </div>
                </Col>



                {/* Save and Cancel Buttons */}
                <Col md="12">
                  <div className="flex gap-3 items-center">
                    <Button disabled={isLoading} color="primary" type="submit">
                      {isLoading ? <Spinner size="sm" color="light" /> : "Yes"}
                    </Button>

                    <Button disabled={isLoading} color={"danger"} type="reset" onClick={()=>onClick()}>
                      No
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default AssignSpecialistForm;
